import { z } from 'zod';
import { paginationQueryResponse } from './pagination';

export const learningPathSchema = z.object({
  data: z.array(
    z.object({
      id: z.nullable(z.number()),
      documentId: z.nullable(z.string()),
      title: z.nullable(z.string()),
      description: z.nullable(z.string()),
      numberOfLessons: z.nullable(z.number()),
      requirements: z.nullable(z.string()),
      progress: z.nullable(z.number()),
      numberOfVideos: z.nullable(z.number()),
      skillLevel: z.nullable(z.object({ name: z.nullable(z.string()) })),
      duration: z.nullable(z.number()),
      isHighlighted: z.nullable(z.boolean()),
      thumbnail: z.nullable(z.object({ url: z.nullable(z.string()) })),
      teacherProfiles: z.nullable(
        z.array(
          z.nullable(
            z.object({
              displayName: z.nullable(z.string()),
              profilePicture: z.nullable(z.object({ url: z.nullable(z.string()) })),
            }),
          ),
        ),
      ),
    }),
  ),
  pagination: paginationQueryResponse,
});

export type LearningPath = z.infer<typeof learningPathSchema>;
